import { render, staticRenderFns } from "./tab5AssociateSecretarySpecialEducationAnalysis.vue?vue&type=template&id=5ad67864&scoped=true"
import script from "./tab5AssociateSecretarySpecialEducationAnalysis.vue?vue&type=script&lang=js"
export * from "./tab5AssociateSecretarySpecialEducationAnalysis.vue?vue&type=script&lang=js"
import style0 from "./tab5AssociateSecretarySpecialEducationAnalysis.vue?vue&type=style&index=0&id=5ad67864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad67864",
  null
  
)

export default component.exports